export default "__VITE_ASSET__BN2f7hlL__"